import React, {useState,useEffect,useRef}from 'react'
import Spinner from './Spinner';
import axios from 'axios';
import config from '../config.json'

export default function ProjectInfo(props) {
    const [loading,setLoading] = useState(true);
    const [projData,setProjData] = useState(null);
    const nameRef = useRef(null);
    const titleRef = useRef(null);
    const emailRef = useRef(null);
    const serverURL = config.serverURL;
    const token = props.token;
    const fail = props.fail;
    const completed = props.completed;
    const update = props.update;
    const updateContact = props.updateContact;

    const initData = async function(){
        if(token =='sample'){
            var res = {};
            res.clientName = 'Michael Scott'
            res.clientTitle = 'Regional Manager'
            res.prj_name = 'Dunder Mifflin Paper Co. Remodel'
            res.pm_emp_name = 'Dwight Schrute'
            res.prj_code = 'SCRA123'
            setProjData(res);
        }
        else{
            try{
                var res = await axios.get(serverURL+'/api/Survey/ProjInfo?accessGuid='+token);
                console.log(res.data);
                if(res.data.csdDate != null){
                    setCompleted();
                }
                setProjData(res.data);
                update(res.data.csd_id);
            }
            catch(e){
                // Pass the HTTP status up (0 = network error) so the parent
                // can show the right fallback page.
                fail(e.response ? e.response.status : 0);
                console.log(e)
            }
        }
    }

    const updateWrapper = function(){
        updateContact(nameRef.current.value, titleRef.current.value, emailRef.current.value);
    }

    useEffect(()=>{
        initData().then(()=>{
            setLoading(false);
        });
    },[]);

    const setCompleted = function(){
        completed();
    }


    if (loading) return <Spinner/>
    if (projData == null) return null;
    return (
        <>
        <hr/>
        <div className='row'>
            <div className='col-6'>
                <div className='row'>
                    <div className='col-2 h6'>
                        Name:
                    </div>
                    <div className='col '>
                        {projData.clientName}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-2 h6'>
                        Title:
                    </div>
                    <div className='col '>
                        {projData.clientTitle}
                    </div>
                </div>
            </div>
            <div className='col-6'>
                <div className='row'>
                    <div className='col-3 h6'>
                        Project:
                    </div>
                    <div className='col '>
                        {(projData.alt_proj_name != null? projData.alt_proj_name: projData.prj_name)+' ('+projData.prj_code+')'}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-3 h6'>
                        FNI Project Manager:
                    </div>
                    <div className='col '>
                        {projData.pm_emp_name}
                    </div>
                </div>
            </div>
        </div>
        <hr/>
        <div className='row'>
            <p className='h6'>If you are not {projData.clientName}, please provide the following information </p>
            <div className='col h6'>
                <label htmlFor="changeName">Name:</label>
                <input type="text" className="form-control" id='changeName' ref={nameRef} onChange = {()=>{updateWrapper()}}/>
            </div>
            <div className='col h6'>
                <label htmlFor="changeName">Title:</label>
                <input type="text" className="form-control" id='changeTitle' ref={titleRef} onChange = {()=>{updateWrapper()}}/>
            </div>
            <div className='col h6'>
                <label htmlFor="changeName">Email:</label>
                <input type="text" className="form-control" id='changeEmail' ref={emailRef} onChange = {()=>{updateWrapper()}}/>
            </div>
        </div>
        <hr/>
        </>
    )
}
